import { BaseApi, ResponseEntity } from "@/utils/request";

export class NewsApi extends BaseApi {
  constructor() {
    super();
  }

  /**
   * 时文Section
   */
  public getOptionsSection(): Promise<ResponseEntity> {
    return this.get("/Contents/GetOptionsSection");
  }

  /**
   * 时文Section
   */
  public getBasicContentByType(
    type: number,
    pageNum = 1,
    limit = 10,
    orderColumn = "ID"
  ): Promise<ResponseEntity> {
    const data: object = {
      orderColunm: orderColumn,
      orderDir: "DESC",
      limit: limit,
      page: pageNum,
      ContentType: type,
    };
    return this.get("/Contents/GetBasicContentByType", data);
  }

  /**
   * 时文列表热门数据
   */
  public getHotsData(): Promise<ResponseEntity> {
    return this.get("/Contents/GetOptionsListHots");
  }

  /**
   * 时文Section
   */
  public getContentTypesByParentId(parentId: number): Promise<ResponseEntity> {
    return this.get("/Contents/GetContentTypesByParentId?parentId=" + parentId);
  }

  /**
   * 时文Section
   */
  public getImageTextSection(parentId : number): Promise<ResponseEntity> {
    return this.get("/Contents/GetImageTextSection?parentId="+parentId);
  }

  /**
   * 文字详情
   * @param id
   */
  public getNewsInfo(id: number): Promise<ResponseEntity> {
    return this.get("/Contents/GetContentDetail", { id });
  }

  /**
   * 全局搜索
   */
  public searchList(
    pageNum = 1,
    limit = 10,
    searchKey = "",
    contentType: string,
    orderColumn = "ID"
  ): Promise<ResponseEntity> {
    const data: object = {
      orderColunm: orderColumn,
      orderDir: "DESC",
      limit: limit,
      page: pageNum,
      contentType,
      searchKey,
    };
    return this.get("/Contents/SearchList", data);
  }

  /**
   * 文章评论
   * @param id
   */
  public comment(
    id: number,
    comment: string,
    parentId = 0
  ): Promise<ResponseEntity> {
    return this.post("/Contents/Comment", { id, comment, parentId });
  }

  public getExtInfo(id: number) {
    return this.get("/Contents/GetExtInfo", { id });
  }
}
